import { useEffect, useState } from "react";

export const useTimer = ({ initialTime }) => {
  const [time, setTime] = useState();
  const [timeInterval, setTimeInterval] = useState();

  const getFormattedTime = () => {
    if (typeof time !== "number") {
      return "";
    }

    let hours = Math.floor(time / 3600);
    let minutes = Math.floor((time - hours * 3600) / 60);
    let seconds = time - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = `0${hours}`;
    }

    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    return `${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (initialTime) {
      if (timeInterval) {
        clearInterval(timeInterval);
      }

      const now = new Date().getTime();
      const initialTimeDate = new Date(initialTime);
      const timeDiff = parseInt((now - initialTimeDate) / 1000, 10);
      setTime(timeDiff);

      setTimeInterval(
        setInterval(() => {
          setTime((currentTime) => currentTime + 1);
        }, 1000)
      );
    }

    return () => {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
    };
  }, [initialTime]);

  return {
    time: getFormattedTime(),
  };
};
